export default __webpack_public_path__ + "static/media/gnpl.0a21b098.png";